import { IDisposable } from "Global/Base/IDisposable";

/**
 * Obecné popup okno, které se (na vyžádání) umí vhodně umístit u zadaného HTML elementu.
 * (Tak, aby ideálně bylo celé vidět a nebylo skryté za hranicí obrazovky.)
 * - Popup okno samo o sobě neřeší svůj obsah. Ten mu musí být poskytnut zvenku.
 * - Název `PopupMenu` je historický. Dříve se používalo výhradně v souvislosti s menu.
 * - Dnes se běžně používá i pro jiné účely, typicky pro zobrazení tooltipu s chybovou hláškou.
 */
export interface IPopupMenu extends IDisposable {
    /**
     * Příznak, zda-li je popupMenu viditelné.
     */
    readonly visible: boolean;

    /**
     * Element reprezentující popupMenu v HTML DOM. (Tento element je předmětem pozicování.)
     */
    readonly element: HTMLElement;

    /**
     * Umístí popupMenu k `targetControlElement`, se snahou umístit tak, aby byl celý popupMenu viditelný. (Aby nebyl vykreslený mimo obrazovku.)
     * @param popUpElement HTML element, do kterého se vykresluje obsahu popupMenu.
     * @param targetControlElement HTML element, u kterého má být popupMenu umístěno.
     * @param hasFocus `True`, pokud `targetControlElement` má fokus. Používá se pouze při zadaném `gridRect`.
     * @param gridRect Určeno pro použití na datagridu. Pokud zadáno a zároveň `hasFocus`, pak se - za určitých okolností - nastaví viditelnost popupMenu.
     * Historická props. Již se nepoužívá.
     * @param width Předdefinovaná výchozí šířka elementu `targetControlElement`.
     * Pokud zadáno, bude - při výpočtu pozice popupMenu - upřednostněna před šířkou `targetControlElement`.
     * (Zavedeno kvůli `LOV`, protože grid má před dočtením nulovou šířku a drop down menu se zobrazovalo jen jako tečka.)
     * @param height Analogicky jako `width`.
     */
    arangePopupToEditableControl(popUpElement: HTMLElement, targetControlElement: HTMLElement, hasFocus: boolean, gridRect?: ClientRect, width?: SizeType, height?: SizeType): void;

    /**
     * Nastavi viditelnost popupMenu.
     * @param visible `True`, pokud má být popupMenu viditelné.
     */
    setVisibility(visible: boolean): void;

    /**
     * Nastavení odsazení.
     * @param top odsazení od vrchního okraje stránky
     * @param left odsazení od levého okraje stránky
     * @param bottom odsazení od dolního okraje stránky
     * @param right odsazení od pravého okraje stránky
     */
    setIndent(top?: string, left?: string, bottom?: string, right?: string): void;
}

export type SizeType = number | "auto" | "fit-content" | "min-content" | "max-content";
